module.exports = __webpack_public_path__ + "static/media/Riser-Pipe-Ico.33e757d9.svg";